import { render } from "./ListViewPage.vue?vue&type=template&id=4b38efb8"
import script from "./ListViewPage.vue?vue&type=script&lang=js"
export * from "./ListViewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__